import { render, staticRenderFns } from "./HR.vue?vue&type=template&id=76793b50&scoped=true"
import script from "./HR.vue?vue&type=script&lang=js"
export * from "./HR.vue?vue&type=script&lang=js"
import style0 from "./HR.vue?vue&type=style&index=0&id=76793b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76793b50",
  null
  
)

export default component.exports